import { useSelector } from "react-redux";

import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";

import { RefundInitiationFilterPage } from "./refundInitiationFilter/RefundInitiationFilterPage";
import { RefundInitiationTablePage } from "./refundInitiationTable/RefundInitiationTablePage";
import classes from "./refundInitiationListPage.module.css";
import { selectRefundInitiationState } from "../../store/refund_initiation/refundFilterSlice";
import {
  selectRefundInitiations,
  useGetRefundInitiationListQuery,
} from "../../services/refund_initiation/refundInitiationApiSlice";

export const RefundInitiationListPage = () => {
  const appliedFilters = useSelector(selectRefundInitiationState);
  const { isSuccess } = useGetRefundInitiationListQuery(appliedFilters);

  const tableData = useSelector(selectRefundInitiations);

  return isSuccess ? (
    <div className={classes.box}>
      <RefundInitiationFilterPage />
      <RefundInitiationTablePage data={tableData} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
